import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './njitCatalog.scss';
import CatalogCard from './njitCatalogCard';
import { Pagination } from '@material-ui/lab';

declare var jQuery: any;

class NjitCatalog extends Component {


	constructor(props) {
		super(props);
		this.accessTypes=['Standard Access','Assisted Use Only','Staff Use Only','Submit a Job'];
		this.state = {
		loaded: false,
		error: null,
		// original flat list you used:
		data: [],
		// new structured state:
		programsWithCourses: [], // [{ program, courses: [] }]
		standaloneCourses: [],   // courses not referenced by any program
		// pagination (optional – currently unused):
		currentPage: 1,
		itemsPerPage: 20,
		totalPage: 0,
		};
		
	}

	componentDidMount() {
	const coursesReq  = axios.get("/api/courses");
	const programsReq = axios.get("/api/programs");

	// Active if NOT (enrollment_open_to < now OR end_date < now)
	function isActive(x) {
		if (!x) return false;
		var now = new Date();

		if (x.enrollment_open_to) {
		var until = new Date(x.enrollment_open_to);
		if (!isNaN(until.getTime()) && until < now) return false;
		}
		if (x.end_date) {
		var end = new Date(x.end_date);
		if (!isNaN(end.getTime()) && end < now) return false;
		}
		return true;
	}

	// Safe sort helper for list_order (treat missing as big number so they sink)
	function byListOrder(a, b) {
		var la = (a && a.list_order !== undefined) ? a.list_order : Number.MAX_SAFE_INTEGER;
		var lb = (b && b.list_order !== undefined) ? b.list_order : Number.MAX_SAFE_INTEGER;
		return la - lb;
	}

	Promise.all([coursesReq, programsReq])
		.then(([cRes, pRes]) => {
		var rawCourses  = (cRes.data && cRes.data.courses ? cRes.data.courses : [])
			.filter(function(c){ return c.visibility === 'listed' && isActive(c); });

		var rawPrograms = (pRes.data && pRes.data.programs ? pRes.data.programs : [])
			.filter(function(p){ return p.visibility === 'listed'; });

		// Sort by list_order only
		var courses  = rawCourses.slice().sort(byListOrder);
		var programs = rawPrograms.slice().sort(byListOrder);

		// Index courses by id
		var courseById = new Map(courses.map(function(c){ return [c.id, c]; }));
		var assigned = new Set();

		// Collect course IDs from program requirements (handles nested Program refs)
		function collectCourseReqs(node, bag) {
			bag = bag || [];
			var reqs = (node && node.requirements) ? node.requirements : [];
			for (var i = 0; i < reqs.length; i++) {
			var r = reqs[i];
			if (r.type === 'Course') {
				bag.push(r.id);
			} else if (r.type === 'Program') {
				collectCourseReqs(r, bag);
			}
			}
			return bag;
		}

		// Build programs with their courses (also sorted by list_order)
		var programsWithCourses = programs.map(function(program){
			var ids = Array.from(new Set(collectCourseReqs(program, [])));
			var programCourses = ids
			.map(function(id){ return courseById.get(id); })
			.filter(function(c){ return !!c && isActive(c); })
			.sort(byListOrder);

			ids.forEach(function(id){ assigned.add(id); });

			return { program: program, courses: programCourses };
		});

		// Standalone courses (not referenced by any program)
		var standaloneCourses = courses.filter(function(c){ return !assigned.has(c.id); });

		// Combined list
		var combinedItems = [];

		for (var i = 0; i < programsWithCourses.length; i++) {
			var pwc = programsWithCourses[i];
			if (pwc.courses && pwc.courses.length > 0) {
			combinedItems.push({
				kind: 'program',
				sort_val: pwc.program.list_order,
				program: pwc.program,
				courses: pwc.courses
			});
			}
		}

		for (var j = 0; j < standaloneCourses.length; j++) {
			var c = standaloneCourses[j];
			combinedItems.push({
			kind: 'course',
			sort_val: c.list_order,
			course: c
			});
		}

		// Final sort for display by list_order
		combinedItems.sort(function(a, b){
			var la = (a.sort_val !== undefined) ? a.sort_val : Number.MAX_SAFE_INTEGER;
			var lb = (b.sort_val !== undefined) ? b.sort_val : Number.MAX_SAFE_INTEGER;
			return la - lb;
		});

		this.setState({
			programsWithCourses: programsWithCourses,
			standaloneCourses: standaloneCourses,
			combinedItems: combinedItems,
			data: courses,
			loaded: true,
			totalPage: Math.ceil(courses.length / this.state.itemsPerPage),
		});

		console.log('Combined (sorted by list_order only):', combinedItems);
		})
		.catch((error) => {
		console.error("Catalog load error:", error);
		this.setState({ error: error.message, loaded: true });
		});
	}



	handlePageChange = (event, value) => {
		event.preventDefault();
		this.setState({ currentPage: value });
	};

	render() {
		const { currentPage, itemsPerPage } = this.state;
		const combinedItems = this.state.combinedItems || [];

		const indexOfLastItem = currentPage * itemsPerPage;
		const indexOfFirstItem = indexOfLastItem - itemsPerPage;
		const currentItems = combinedItems.slice(indexOfFirstItem, indexOfLastItem);

		// total = programs (1 each) + their courses + standalone courses
		const totalExpandedCount = combinedItems.reduce((acc, item) => {
			if (item.kind === 'program') {
			const n = item.courses ? item.courses.length : 0;
			return acc + 1 + n;
			}
			return acc + 1;
	}, 0);

	// 🔢 Use expanded count for total pages
	const totalPages = Math.ceil(totalExpandedCount / itemsPerPage);
		const output = currentItems.map((item, i) => {
		if (item.kind === 'program') {
			return (
			<React.Fragment>
				<CatalogCard d={item.program} i={i} isProgram={true} courseCount={item.courses.length} />
				{item.courses.map((c, j) => (
					<CatalogCard key={c.id || `pc-${j}`} d={c} i={j} isProgram={false} />
				))}
			</React.Fragment>
			);
		} else {
			const d = item.course;
			return <CatalogCard key={d.id || `c-${i}`} d={d} i={i} isProgram={false} />;
		}
		});


  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => (
    <button
      key={number}
      onClick={() => this.handlePageChange(number)}
      className={currentPage === number ? 'active' : ''}
    >
      {number}
    </button>
  ));

  if (!this.state.loaded) {
    return (
      <div className="catalog-wrapper">
        <div className="items">
          <div className="la-ball-grid-pulse">
            <div></div><div></div><div></div>
            <div></div><div></div><div></div>
            <div></div><div></div><div></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="catalog-wrapper">
      <div className="items">
        {output}
      </div>
      {/* If/when you enable pagination UI, totalPages is now based on expanded count */}
    </div>
  );
}

}



NjitCatalog.propTypes = {
  category: PropTypes.array,

};

export default NjitCatalog;


// WEBPACK FOOTER //
// ./src/Catalog/njitCatalog.js